/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState} from "react";
import { Link } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import TableHeader from "../Common/TableHeader";
import Loader from "../Common/Loader";
import TransactionsTable from "../Common/Transactions/TransactionsTable";
import Pagination from "../Common/Pagination";
import ajaxBank from "../../util/remote/ajaxBank";
import TransactionsSearchForm from "../Common/Transactions/TransactionsSearchForm";

function Commissions() {
  const [commissions, setCommissions] = useState(false);
  const [cmSearchTerm, setCmSearchTerm] = useState("");
  const [cmStartDate, setCmStartDate] = useState("");
  const [cmEndDate, setCmEndDate] = useState("");
  const [cmPage,setCmPage] = useState(1)
  const [cmMeta,setCmMeta] = useState([])
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  
  useEffect(() => {
    if (cmSearchTerm || cmStartDate || cmEndDate) {
      searchCommissions();
    } else {
      fetchCommissions(cmPage);
    }
  }, [cmPage]);

  const fetchCommissions = async (currentPage) => {
    setLoading(true);
    const response = await ajaxBank.fetchCommissions(currentPage);
    setLoading(false);
    if (response.status === "OK") {
      setCmMeta(response.details.meta.totalPages);
      setCommissions(response.details.data || []);
    } else {
      setCommissions([]);
    }
  };


  const searchCommissions = async (e) => {
    if (e) e.preventDefault();
    setLoading2(true);
    const response = await ajaxBank.searchCommissions(cmPage, cmStartDate, cmEndDate, cmSearchTerm);
    setLoading2(false);
    if (response.status === "OK") {
      setCmMeta(response.details.meta.totalPages);
      setCommissions(response.details.data || []);
    } else {
      setCommissions([]);
    }
  };

  const resetFilters = (e) => {
    e.preventDefault();
    setCmSearchTerm("");
    setCmStartDate("");
    setCmEndDate("");
    setCmPage(1);
    fetchCommissions(1);
  };

  const exportToPDF = () => {
    const pdf = new jsPDF("p", "pt", "a4");
    const columns = ["Date & Time", "User", "Transaction Number", "Amount"];
    const data = commissions.map(item => [
      `${item.created_at?.short_date} ${item.created_at?.time}`,
      `${item.user} (${item.username})`,
      item.transaction_number,
      `UGX. ${item.amount}`,
    ]);

    pdf.autoTable({ head: [columns], body: data });
    pdf.save("commissions_data.pdf");
  };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= cmMeta) {
      setCmPage(newPage);
    }
  };

  const headers = [
    { label: "Transaction Date", key: "cm_created_at" },
    { label: "Amount", key: "amount_invoiced" },
    { label: "Description", key: "cm_description" },
    { label: "Vendor Name", key: "transactors"},
    { label: "Transaction Number", key: "transaction_number" }

  ];

  

  return (
    <>
      <div className="heading-layout1 mg-b-5">
        <TableHeader
            subtitle="List of all the commissions made sorted by the most recent"
        />
        <div className="dropdown">
          <Link className="dropdown-toggle" role="button" data-toggle="dropdown">...</Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link className="dropdown-item" onClick={exportToPDF}>
              <i className="fas fa-file-export"></i>Export
            </Link>
          </div>
        </div>
      </div>

      <TransactionsSearchForm searchTerm={cmSearchTerm} setSearchTerm={setCmSearchTerm} startDate={cmStartDate}
         setStartDate={setCmStartDate} endDate={cmEndDate} setEndDate={setCmEndDate} searchTransactions={searchCommissions}
         setTransactions={resetFilters} setPage={setCmPage} searchTermPlaceholder="Enter transaction number..."/>

      
      <div className="border-top mt-3"></div>
      <div className="table-responsive">
        {loading || loading2 ? (
          <Loader />
        ) : (
          <TransactionsTable headers={headers} data={commissions} isPMTransaction={true}/>
        )}
      </div>

      <Pagination currentPage={cmPage} totalPages={cmMeta} onPageChange={handlePagination}/>

    </>
  );
}

export default Commissions;